module.exports = __webpack_public_path__ + "static/media/mirror.9c25374b.jpg";